<div class="td-wrap">

  <a href="javascript:;" class="td-back" (click)="back()"><i class="fa fa-arrow-left"></i> Kembali ke daftar Tahfidz</a>

  <div class="td-card td-hero" *ngIf="isHeaderLoading">
    <div class="vl-loading"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
    <div style="min-height: 120px"></div>
  </div>

  <div class="td-card td-empty" *ngIf="notFound && !isHeaderLoading">
    <i class="fa fa-search"></i>
    <h3>Pengguna tidak ditemukan</h3>
    <p>Pengguna dengan ID {{id}} tidak ada di database.</p>
  </div>

  <ng-container *ngIf="user">
    <!-- hero: who, then the four numbers that matter -->
    <div class="td-card td-hero">
      <div class="td-hero-top">
        <div class="td-photo-wrap">
          <img [src]="user.photoUrl || 'assets/images/no_avatar.webp'" alt="{{user.nameVw}}" class="td-photo round vb-click" title="Lihat foto"
               (click)="openViewer(user.photoUrl)" onerror="this.onerror=null;this.src='assets/images/no_avatar.webp';">
        </div>
        <div class="td-hero-main">
          <div class="td-title-row">
            <h2>{{user.nameVw}}</h2>
            <span class="vl-pill on" *ngIf="user.ayat_30d"><span class="vl-dot"></span>Aktif menghafal</span>
            <span class="vl-pill off" *ngIf="!user.ayat_30d"><span class="vl-dot"></span>Tidak aktif 30 hari</span>
          </div>
          <p class="td-desc vl-muted" *ngIf="user.email">{{user.email}}</p>
          <div class="hd-chips">
            <span class="td-chip"><i class="fa fa-bullseye"></i> {{formatNumber(user.targets_total)}} target</span>
            <span class="td-chip green" *ngIf="user.targets_complete"><i class="fa fa-check"></i> {{formatNumber(user.targets_complete)}} selesai</span>
            <span class="td-chip" *ngIf="user.targets_ongoing"><i class="fa fa-play"></i> {{formatNumber(user.targets_ongoing)}} berjalan</span>
            <span class="td-chip danger" *ngIf="user.targets_overdue"><i class="fa fa-exclamation-circle"></i> {{formatNumber(user.targets_overdue)}} lewat tenggat</span>
          </div>
        </div>
        <span class="tl-readonly" title="Halaman ini hanya untuk memantau"><i class="fa fa-eye"></i> Hanya lihat</span>
      </div>

      <div class="td-facts">
        <div class="td-fact">
          <span class="td-fact-ico"><i class="fa fa-calendar"></i></span>
          <span class="td-fact-body"><span class="td-fact-l">Mulai menghafal</span><span class="td-fact-v">{{user.firstTargetVw}}</span></span>
        </div>
        <div class="td-fact">
          <span class="td-fact-ico"><i class="fa fa-clock"></i></span>
          <span class="td-fact-body"><span class="td-fact-l">Terakhir menandai hafal</span><span class="td-fact-v" [title]="user.lastProgressFull">{{user.lastProgressVw}}</span></span>
        </div>
        <div class="td-fact">
          <span class="td-fact-ico"><i class="fa fa-bolt"></i></span>
          <span class="td-fact-body"><span class="td-fact-l">30 hari terakhir</span><span class="td-fact-v">{{formatNumber(user.ayat_30d)}} ayat <span class="vl-muted">&middot; 7 hari: {{formatNumber(user.ayat_7d)}}</span></span></span>
        </div>
        <div class="td-fact">
          <span class="td-fact-ico"><i class="fa fa-sign-in-alt"></i></span>
          <span class="td-fact-body"><span class="td-fact-l">Terakhir login</span><span class="td-fact-v">{{user.lastSignVw}}</span></span>
        </div>
      </div>

      <div class="td-stats">
        <div class="td-stat">
          <span class="td-label">Ayat Dihafal</span>
          <span class="td-num">{{formatNumber(user.ayat_hafal)}}</span>
          <span class="td-kpi-foot"><span class="tl-bar"><span class="tl-bar-fill" [style.width.%]="user.quranPct"></span></span>{{user.quranPctVw}}% dari 6.236 ayat</span>
        </div>
        <div class="td-stat">
          <span class="td-label">Surat Tersentuh</span>
          <span class="td-num">{{formatNumber(user.surahs_touched)}}</span>
          <span class="td-kpi-foot">{{formatNumber(user.surahs_complete)}} surat hafal seluruhnya</span>
        </div>
        <div class="td-stat">
          <span class="td-label">Target Selesai</span>
          <span class="td-num">{{formatNumber(user.targets_complete)}}<span class="td-num-of">/{{formatNumber(user.targets_total)}}</span></span>
          <span class="td-kpi-foot"><span class="tl-bar"><span class="tl-bar-fill done" [style.width.%]="user.completePct"></span></span>{{user.completePct}}%</span>
        </div>
        <div class="td-stat">
          <span class="td-label">Lewat Tenggat</span>
          <span class="td-num" [class.tl-warn]="user.targets_overdue">{{formatNumber(user.targets_overdue)}}</span>
          <span class="td-kpi-foot">{{formatNumber(user.targets_ongoing)}} target masih berjalan</span>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="td-tabs" role="tablist">
          <button *ngFor="let t of tabs" type="button" role="tab" class="td-tab" [class.on]="tab == t.key"
                  [attr.aria-selected]="tab == t.key" (click)="openTab(t.key)">{{t.label}}</button>
        </div>

        <!-- ---------- TARGET ---------- -->
        <div class="vl-card" *ngIf="tab == 'targets'">
          <div class="vl-loading" *ngIf="loading.targets"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
          <div class="td-subbar">
            <div class="tl-seg" role="tablist" aria-label="Filter status target">
              <button type="button" [class.on]="targetFilter == ''" (click)="targetFilter = ''">Semua <b>{{targetCount('')}}</b></button>
              <button type="button" [class.on]="targetFilter == 'ongoing'" (click)="targetFilter = 'ongoing'">Berjalan <b>{{targetCount('ongoing')}}</b></button>
              <button type="button" [class.on]="targetFilter == 'complete'" (click)="targetFilter = 'complete'">Selesai <b>{{targetCount('complete')}}</b></button>
              <button type="button" [class.on]="targetFilter == 'overdue'" (click)="targetFilter = 'overdue'">Lewat tenggat <b>{{targetCount('overdue')}}</b></button>
            </div>
            <div class="vl-spacer"></div>
            <span class="vl-muted vl-small">Klik target untuk melihat rincian per surat dan peta ayatnya</span>
          </div>
          <div class="vl-scroll">
          <table class="vl-table">
            <thead><tr><th class="vl-num">No</th><th>Target</th><th>Mode</th><th style="width: 20%">Progres</th><th>Tenggat</th><th>Aktivitas Terakhir</th><th>Status</th></tr></thead>
            <tbody>
            <ng-container *ngFor="let v of visibleTargets; let i = index">
              <tr class="vl-row tl-rowlink" [class.vl-alt]="i % 2 == 1" (click)="toggleTarget(v)">
                <th class="vl-num">{{i + 1}} <span class="vl-chev" [class.open]="exp(v).open"><i class="fa" [ngClass]="exp(v).loading ? 'fa-spinner fa-spin' : 'fa-chevron-right'"></i></span></th>
                <td><span class="vl-name">{{v.title}}</span><div class="vl-muted vl-small">{{v.range_text}} &middot; {{formatNumber(v.total_ayat)}} ayat<ng-container *ngIf="v.surah_count > 1"> &middot; {{v.surah_count}} surat</ng-container></div></td>
                <td><span class="vl-tag" [class.nafas]="v.mode == 1" [class.potongan]="v.mode != 1">{{v.modeVw}}</span><div class="vl-muted vl-small">{{formatNumber(v.repeat_count)}}&times; ulang</div></td>
                <td><div class="td-part wide"><span class="tl-bar"><span class="tl-bar-fill" [class.done]="v.is_complete" [style.width.%]="v.pct"></span></span><span>{{v.pct}}%</span></div><div class="vl-muted vl-small">{{formatNumber(v.hafal_count)}}/{{formatNumber(v.total_ayat)}} ayat</div></td>
                <td>{{v.targetVw || '—'}}<div class="vl-small" [class.vl-muted]="v.status != 'overdue'" [class.tl-warn]="v.status == 'overdue'">{{v.deadlineVw}}</div></td>
                <td><span [title]="v.lastProgressFull">{{v.lastProgressVw}}</span></td>
                <td><span class="vl-pill" [class.on]="v.status == 'complete'" [class.wait]="v.status == 'ongoing'" [class.del]="v.status == 'overdue'"><span class="vl-dot"></span>{{statusLabel(v.status)}}</span></td>
              </tr>
              <tr *ngIf="exp(v).open && exp(v).surahs" class="td-child">
                <td colspan="7">
                  <div class="hm-wrap inset">
                    <div class="hm-surah" *ngFor="let s of exp(v).surahs">
                      <div class="hm-surah-head">
                        <b>{{s.name}}</b>
                        <span class="vl-muted vl-small">{{s.rangeVw}} &middot; {{s.hafal}}/{{s.count}} hafal ({{s.pct}}%) &middot; terakhir {{s.lastVw}}</span>
                      </div>
                      <div class="hm-grid"><span *ngFor="let a of s.ayahs" class="hm-cell" [class.hafal]="a.hafal" [title]="a.title">{{a.ayah}}</span></div>
                    </div>
                    <div class="vl-muted vl-small" *ngIf="!exp(v).surahs.length">Rentang target tidak dikenali</div>
                  </div>
                </td>
              </tr>
            </ng-container>
            <tr *ngIf="!visibleTargets.length && !loading.targets"><td colspan="7" class="vl-empty">Tidak ada target pada filter ini</td></tr>
            </tbody>
          </table>
          </div>
        </div>

        <!-- ---------- PETA HAFALAN ---------- -->
        <div class="vl-card" *ngIf="tab == 'map'">
          <div class="vl-loading" *ngIf="loading.map"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
          <div class="td-subbar">
            <span class="vl-muted vl-small">Seluruh ayat yang pernah ditandai hafal, per surat. Satu kotak = satu ayat; arahkan kursor untuk tanggalnya.</span>
            <div class="vl-spacer"></div>
            <span class="td-legend"><i class="complete"></i> Hafal</span>
            <span class="td-legend"><i class="untouched"></i> Belum</span>
          </div>
          <div class="hm-wrap">
            <div class="hm-surah" *ngFor="let s of map">
              <div class="hm-surah-head">
                <b>{{s.name}}</b>
                <span class="td-chip green" *ngIf="s.is_complete"><i class="fa fa-check"></i> Hafal seluruhnya</span>
                <span class="vl-muted vl-small">{{s.hafal}}/{{s.total_ayah}} ayat ({{s.pct}}%) &middot; terakhir {{s.lastVw}}</span>
              </div>
              <div class="hm-grid"><span *ngFor="let a of s.ayahs" class="hm-cell" [class.hafal]="a.hafal" [title]="a.title">{{a.ayah}}</span></div>
            </div>
            <div class="vl-empty" *ngIf="!map.length && !loading.map">Belum ada ayat yang ditandai hafal</div>
          </div>
        </div>

        <!-- ---------- AKTIVITAS ---------- -->
        <div class="vl-card" *ngIf="tab == 'activity'">
          <div class="vl-loading" *ngIf="loading.activity"><img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data"></div>
          <ul class="tl-feed">
            <li *ngFor="let a of act" class="tl-feed-row">
              <span class="tl-feed-ico ok"><i class="fa fa-check"></i></span>
              <div class="tl-feed-body">
                <div class="tl-feed-text">Menandai hafal <b>{{a.surahName}}</b> {{a.rangeVw}}</div>
                <div class="tl-feed-meta"><span class="vl-tag kind">{{formatNumber(a.ayat_count)}} ayat</span><span>{{a.dayVw}}</span></div>
              </div>
              <time class="tl-feed-time" [title]="a.timeFull">{{a.timeVw}}</time>
            </li>
            <li *ngIf="!act.length && !loading.activity" class="vl-empty">Belum ada ayat yang ditandai hafal</li>
          </ul>
          <div class="vl-foot">
            <span class="vl-summary">Menampilkan <b>{{formatNumber(rangeFrom(actPage, actTotal))}}&ndash;{{formatNumber(rangeTo(actPage, act.length))}}</b> dari <b>{{formatNumber(actTotal)}}</b> aktivitas</span>
            <div class="vl-spacer"></div>
            <nav class="vl-pager" aria-label="Navigasi aktivitas">
              <button type="button" class="vl-page" [disabled]="actPage == 1" (click)="goActPage(actPage - 1)">&lsaquo;</button>
              <ng-container *ngFor="let p of actPages">
                <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == actPage" (click)="goActPage(p)">{{p}}</button>
              </ng-container>
              <button type="button" class="vl-page" [disabled]="actPage == pagesOf(actTotal)" (click)="goActPage(actPage + 1)">&rsaquo;</button>
            </nav>
          </div>
        </div>

      </div>
    </div>
  </ng-container>
</div>

<div class="vb-viewer" *ngIf="isViewer" (click)="closeViewer()">
  <img [src]="isViewer" alt="Foto">
  <button type="button" class="vb-viewer-close" title="Tutup" aria-label="Tutup">&times;</button>
</div>
